import { differenceInHours } from 'date-fns';

const plural = (count: number, unit: string) =>
  `${count} ${unit}${count === 1 ? '' : 's'}`;

/**
 * How long a submission has waited: hours under a day ("5h"), whole days
 * after ("3d"), with the spelled-out `title` for hover.
 */
export function waitingTime(submittedAt: string, now = new Date()) {
  // A server clock slightly ahead of the browser must not read negative.
  const hours = Math.max(0, differenceInHours(now, new Date(submittedAt)));
  const days = Math.floor(hours / 24);

  if (hours < 1) return { days, label: '<1h', title: 'less than an hour' };
  if (days < 1)
    return { days, label: `${hours}h`, title: plural(hours, 'hour') };
  return { days, label: `${days}d`, title: plural(days, 'day') };
}
